// The Ideas Lab's URL: ids and codes only (docs/CONTRACTS.md section 5). `idea` is the open card's id (ia_…), `family` an offer
// family code that filters the board. Its own module, so the screen never imports routes.tsx for a value (section 23.6).
export const FAMILY_CODES = ['tusen', 'betong', 'sauda', 'tommy'] as const
export type FamilyCode = (typeof FAMILY_CODES)[number]
export interface IdeasSearch {
  idea?: string
  family?: FamilyCode
}

const IDEA_ID = /^ia_[0-9a-hjkmnp-tv-z]{26}$/

export function parseSearch(search: Record<string, unknown>): IdeasSearch {
  const idea = typeof search.idea === 'string' && IDEA_ID.test(search.idea) ? search.idea : undefined
  const family = FAMILY_CODES.find((f) => f === search.family)
  return { ...(idea ? { idea } : {}), ...(family ? { family } : {}) }
}
